import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    qrDialogImage: {
      width: 220,
      height: 220,
      display: "block",
      margin: "0 auto",
      "& svg, & canvas": {
        display: "block",
        width: "100%",
        height: "100%",
      },
    },
  })
);

export interface StoreUrlQrDialogProps {
  url: string | null;
  onClose: () => void;
}

export const StoreUrlQrDialog: React.VFC<StoreUrlQrDialogProps> = ({
  url,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog open={!!url} onClose={onClose} maxWidth="xs">
      <DialogTitle>QRコード</DialogTitle>
      <DialogContent>
        {url && (
          <div
            className={classes.qrDialogImage}
            role="img"
            aria-label="ストアURLのQRコード"
          >
            <QRCodeCanvas value={url} size={220} includeMargin />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};
